<template>
  <div>
    <v-card>
      <v-card-title>Estados del Wellboat</v-card-title>
      <v-card-text>
        <botonera 
          :botones="botones" 
          alinear="right"
          @crear="dialog = !dialog"
        ></botonera>
      </v-card-text>
    </v-card>
    <datatable 
      :cabeceras="estadosListHeaders" 
      :items="estadosListBody" 
      titulo="Listado de Estados" 
      label="Escriba Para buscar Estado" 
      icono="list" 
      color_icono="azul"
      :tachar="false"
      :acciones="['editar','eliminar']"
      @editar="editEstado($event)"
      @eliminar="deleteEstado($event)"
    >
    </datatable>
    <!-- Modal Nuevo Estado -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue darken-1">{{ title }}</v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-col>
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Nombre"
                v-model="estado.nombre"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
              <v-btn
                @click="closeModal"
              >Cerrar</v-btn>
              <v-btn
                color="primary"
                @click="saveEstado"
              >Grabar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      title: 'Nuevo Estado',
      color: 'green',
      snackbar: false,
      errors: [],
      validation_message: '',
      success: null,
      search: null,
      dialog: false,
      estadoIndex: -1,
      estado: {
        id: 0,
        nombre: '',
      },
      estadosListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'nombre',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "blue-grey darken-4 white-text"
        },
      ],
      estadosListBody: [],
      botones:[
        {boton:'crear', tooltip:'Nuevo Estado'},
        //{boton:'cargar',tooltip:'Carga Masiva'},
        //{boton:'eliminar',tooltip:'Borrar Todo'}
      ]
    }),
    mounted() {
      this.loadEstados();
    },
    methods:{
      async loadEstados(){
        this.mostrarLoading('Cargando listado de estados...')
        let url = `${this.base_url}estados_wellboats`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.estadosListBody = response.data;
          this.ocultarLoading()
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading()
        });
      },
      async saveEstado(){
        // validation
        this.errors = [];
        if(!this.estado.nombre){
          this.errors.push("Debe indicar nombre de la estado");
        }else if(this.estado.nombre.length > 20){
          this.errors.push("Tamaño máximo nombre: 20 caracteres");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}estados_wellboats`;
        let estadoData = {
          'abreviatura': this.estado.abreviatura,
          'nombre': this.estado.nombre,
        };
        if(this.estado.id > 0){
          url = url + "/" + this.estado.id;
          await this.axios.put(url, estadoData, this.headers).then((response)=>{
            let index = this.estadosListBody.map(estado => {
              return estado.id;
            }).indexOf(this.estado.id);
            this.estadosListBody.splice(index, 1, response.data);
            this.showSnackBar(false);
          }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
          });
        }else{
          await this.axios.post(url, estadoData, this.headers).then((response)=>{
              this.estadosListBody.push(response.data);
              this.showSnackBar(false);
          }).catch((error)=>{
              this.errors = error.response.data;
              this.validation_message = this.errors.join();
              this.showSnackBar(true);
          });
        }
        this.cleanForm();
      },
      editEstado(item) {
        this.estadoIndex = this.estadosListBody.indexOf(item);
        this.estado = Object.assign({}, item);
        this.dialog = true;
        this.title = "Editar Estado";
      },
      async deleteEstado(item) {
        this.$confirm('Desea borrar este estado?').then(res => {
          if(res){
            let url = `${this.base_url}estados/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.estadosListBody.indexOf(item);
              this.estadosListBody.splice(index, 1);
              this.showSnackBar(false);
            }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
            });
          }
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      closeModal(){
        this.cleanForm();
        this.dialog = false;
        this.error = null;
        this.title = "Nuevo Estado";
      },
      cleanForm(){
        this.estado = {
          id: 0,
          nombre: '',
        };
        this.dialog = false;
      },
      async ocultar(item) {
        this.$confirm('Desea ocultar esta estado?').then(res => {
          if(res){
            let url = `${this.base_url}estados/ocultar/${item.id}`;
            this.axios.get(url, this.headers).then((response)=>{
              console.log(response);
              this.showSnackBar(false);
              this.loadEstados();
            }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
            });
          }
        });
      },
      async mostrar(item) {
        this.$confirm('Desea mostrar esta estado?').then(res => {
          if(res){
            let url = `${this.base_url}estados/mostrar/${item.id}`;
            this.axios.get(url, this.headers).then((response)=>{
              console.log(response);
              this.showSnackBar(false);
              this.loadEstados();
            }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
            });
          }
        });
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['loading', 'base_url', 'headers']),
      
    },
    components:{
      
    }
  }
</script>